import React from "react";

export default function Terms() {
  return (
    <div style={{ maxWidth: 900, margin: "130px auto 40px", padding: "0 20px" }}>
      <h1 style={{ marginBottom: 6 }}>Terms of Service</h1>
      <p style={{ color: "#555", marginTop: 0 }}>Effective date: August 13, 2025</p>

      <h2>Acceptance</h2>
      <p>By using GraduationScope you agree to these Terms and to our Privacy Policy.</p>

      <h2>Eligibility and accounts</h2>
      <p>
        You must be at least 13 years old, and at least 16 in some regions. Keep your account credentials
        confidential and you are responsible for activity on your account.
      </p>

      <h2>License to use the service</h2>
      <p>
        We grant you a limited, non-exclusive, non-transferable license to use the site for personal,
        non-commercial use.
      </p>

      <h2>User content</h2>
      <p>
        If you post or submit content you grant GraduationScope a worldwide license to host, store, display,
        and distribute that content for operating and improving the service. You represent that you have the
        rights to what you submit.
      </p>

      <h2>Prohibited conduct</h2>
      <p>
        Do not scrape at scale, reverse engineer, interfere with the site, upload malware, misrepresent your
        identity, or use the service in violation of law or school policies.
      </p>

      <h2>Information and recommendations</h2>
      <p>
        GraduationScope provides class information and recommendations for general informational purposes.
        We do not guarantee accuracy, availability, grades, or outcomes. The service is not a substitute for
        academic advising. You are responsible for your enrollment decisions.
      </p>

      <h2>Third-party links and data</h2>
      <p>
        The site may link to or display content from third parties. We are not responsible for third-party
        sites or services.
      </p>

      <h2>Intellectual property</h2>
      <p>
        All content, features, and trademarks on the site are owned by GraduationScope or its licensors.
        All rights reserved.
      </p>

      <h2>DMCA</h2>
      <p>
        If you believe your copyright is infringed, contact us at{" "}
        <a href="mailto:eli9keys@gmail.com">eli9keys@gmail.com</a> with a detailed notice and we will respond
        consistent with the DMCA.
      </p>

      <h2>Termination</h2>
      <p>
        We may suspend or terminate access if you violate these Terms or if we discontinue the service. You
        may stop using the service at any time.
      </p>

      <h2>Disclaimers</h2>
      <p>
        The service is provided “as is” and “as available.” We disclaim warranties of merchantability,
        fitness for a particular purpose, and non-infringement.
      </p>

      <h2>Limitation of liability</h2>
      <p>
        To the maximum extent permitted by law, GraduationScope and its affiliates will not be liable for
        indirect, incidental, special, consequential, or exemplary damages, or for lost profits or data. Our
        total liability for any claim is limited to the amount you paid to use the service in the 12 months
        before the claim, or 100 dollars if none.
      </p>

      <h2>Indemnification</h2>
      <p>
        You agree to indemnify and hold GraduationScope harmless from claims arising out of your use of the
        service or violation of these Terms.
      </p>

      <h2>Governing law</h2>
      <p>
        These Terms are governed by the laws of the State of California, without regard to conflict of laws.
        Venue is in Carmichael, California.
      </p>

      <h2>Changes to the Terms</h2>
      <p>
        We may modify these Terms by posting an updated version. Continued use means you accept the changes.
      </p>

      <h2>Contact</h2>
      <p>
        Email: <a href="mailto:eli9keys@gmail.com">eli9keys@gmail.com</a>
        <br />
        Mail: Graduation Scope, 3705 Gibbons Parkway
      </p>
    </div>
  );
}
